import { ImageViewerStore } from './types';
import mutations from './mutations';

const state: ImageViewerStore = {
  images: []
};

export default {
  namespaced: true,
  state,
  mutations
};
